import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import "./ordersAdmin.css";
import { toast } from "react-toastify";

function OrdersAdmin() {
  const [orders, setOrders] = useState([]);
  const [statusFilter, setStatusFilter] = useState("all");
  const navigate = useNavigate();

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = () => {
    axiosInstance
      .get("/payment/admin-orders/")
      .then((res) => {
        setOrders(res.data || []);
      })
      .catch((err) => {
        console.error(err);
        setOrders([]);
      });
  };

  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  // ✅ PUT method using ?id=
  const handleStatusChange = (orderId, newStatus) => {
    axiosInstance
      .put(`/payment/admin-orders/?id=${orderId}`, {
        delivery_status: newStatus,
      })
      .then(() => {
        setOrders((prevOrders) =>
          prevOrders.map((order) =>
            order.id === orderId
              ? { ...order, delivery_status: newStatus }
              : order
          )
        );
      })
      .catch((err) => {
        console.error(err);
        toast.error("Failed to update status");
      });
  };

  // ✅ Counts
  const pendingCount = orders.filter(
    (o) => o.delivery_status === "pending"
  ).length;

  const shippedCount = orders.filter(
    (o) => o.delivery_status === "shipped"
  ).length;

  const allCount = orders.length;

  // ✅ Filtered Orders
  const filteredOrders =
    statusFilter === "all"
      ? orders
      : orders.filter((o) => o.delivery_status === statusFilter);

  return (
    <div className="admin-orders">
      <h2 className="admin-orders-title">Orders Management</h2>

      {/* FILTER SECTION */}
      <div className="filter-section">
        <button
          className={statusFilter === "all" ? "active-filter" : ""}
          onClick={() => setStatusFilter("all")}
        >
          All ({allCount})
        </button>

        <button
          className={statusFilter === "pending" ? "active-filter" : ""}
          onClick={() => setStatusFilter("pending")}
        >
          Pending ({pendingCount})
        </button>

        <button
          className={statusFilter === "shipped" ? "active-filter" : ""}
          onClick={() => setStatusFilter("shipped")}
        >
          Shipped ({shippedCount})
        </button>
      </div>

      {filteredOrders.length === 0 && <p>No orders found</p>}

      {filteredOrders.map((order) => (
        <div key={order.id} className="order-card">

          {/* HEADER */}
          <div className="order-header">
            <div>
              <span className="order-id">Order #{order.id}</span>
              <p className="order-date">
                Ordered on: {formatDate(order.created_at)}
              </p>
              {order.num_plate && (
                <p className="num-plate">
                  <span className="plate-badge">
                    🚘 {order.num_plate}
                  </span>
                </p>
              )}
            </div>

            <div className="order-right">
              <span className="order-total">
                ₹{order.total_amount}
              </span>

              <span
                className={`payment-badge ${order.is_paid ? "paid" : "pending-payment"
                  }`}
              >
                {order.is_paid ? "Paid" : "Payment Pending"}
              </span>
            </div>
          </div>

          {/* DELIVERY STATUS */}
          <div className="delivery-section">
            <span
              className={`status-badge ${order.delivery_status === "shipped"
                ? "shipped"
                : "pending"
                }`}
            >
              {order.delivery_status === "shipped"
                ? "Shipped"
                : "Pending"}
            </span>

            <select
              value={order.delivery_status}
              onChange={(e) =>
                handleStatusChange(order.id, e.target.value)
              }
              className="status-select"
            >
              <option value="pending">Pending</option>
              <option value="shipped">Shipped</option>
            </select>
          </div>
          <div className="add-deta">

            <div>
              {order.items.map((item, index) => (
                <div key={index} className="order-item">
                  <img
                    src={item.image ? item.image : "/placeholder.png"}
                    alt={item.product_name}
                    onClick={() =>
                      navigate(`/product/${item.product_id}`)
                    }
                  />

                  <div className="item-info">
                    <h4
                      onClick={() =>
                        navigate(`/product/${item.product_id}`)
                      }
                    >
                      {item.product_name}
                    </h4>

                    <p>Qty: {item.quantity}</p>
                    <p>Price: ₹ {item.price}</p>
                    <p>Size: {item.size}</p>

                    {/* ✅ Number Plate */}
                    {item.number_plate && (
                      <p className="num-plate">
                        <span className="plate-badge">
                          {item.number_plate}
                        </span>
                      </p>
                    )}

                    {/* Color */}
                    {item.color_name && (
                      <div className="color-badge">
                        {/* <span className="color-dot">🎨</span> */}
                        <span className="color-text"> 🎨{item.color_name}</span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            {order.address && (
              <div className="order-address">
                <strong>Delivery Address</strong>
                <p>{order.address.full_name}</p>
                <p>{order.address.phone}</p>
                <p>
                  {order.address.address_line1},{" "}
                  {order.address.city},{" "}
                  {order.address.state} - {order.address.pincode}
                </p>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default OrdersAdmin;
